// imports
import clsx from 'clsx';
import React from 'react';
import { IMAGE } from '../../../assets';
import { LINKS } from '../../../constants';
import { MapViewState, MapImageQuality } from '../../../common/types';
import { ELYSIA_REGION_ID, ELYSIA_REGION_POLYGON } from '../../../constants/lib/map';

// interfaces / types / consts
interface Props {
  quality: MapImageQuality;
  mapViewState: MapViewState;
  onRegionHovered: (hover: boolean) => void;
  onRegionClicked: (regionId: string) => void;
}

// exports
export default function ImageLayer(props: Props): JSX.Element {
  const {
    quality, mapViewState, onRegionHovered, onRegionClicked
  } = props;
  // render
  return (
    <div className="image-layer">
      <img
        alt="worldImg"
        className="map-img"
        src={`${LINKS.MAP_BUCKET_URL}/${quality === 'High' ? 'world' : 'worldLowQuality'}.jpg`}
        onError={({ currentTarget }) => { currentTarget.src = (quality === 'High') ? IMAGE.MAP_WORLD : IMAGE.MAP_WORLD_LOW_QUALITY; }}
      />
      <svg>
        {/* <path
          id={ELYSIA_REGION_ID}
          d={ELYSIA_REGION_POLYGON}
          className={clsx('region-outline', mapViewState === 'default' && 'region-hover')}
          onMouseMove={() => onRegionHovered(true)}
          onMouseLeave={() => onRegionHovered(false)}
          onClick={() => { onRegionClicked(ELYSIA_REGION_ID); }}
        /> */}
      </svg>
    </div>
  );
}
